<template>
	<div class="khpj">
		<div class="khpjContent">
			<myTableSearch :isOperate="true" :operateWidth="250" :formData="formData" :tableLabel="tableLabel"
				:queryFn="queryFn" :queryParams="queryParams" @successQuery="successQuery" :searchColLg="12" ref="tableRef" dataRow="rows">
				<template slot="signStatus" slot-scope="scope">
					<span :style="{ 
						display: 'inline-flex', 
						alignItems: 'center', 
						justifyContent: 'center',
						minWidth: '60px',
						height: '24px',
						padding: '0 12px',
						borderRadius: '4px',
						fontSize: '12px',
						color: '#fff',
						backgroundColor: scope.row.signStatus === 1 ? '#20C980FF' : '#FFC851FF'
					}">
						{{ scope.row.signStatus === 1 ? '已签到' : '未签到' }}
					</span>
				</template>
				<template slot="signType" slot-scope="scope">
					<span>{{ getSignTypeLabel(scope.row.signType) }}</span>
				</template>
				<template slot="tool">
					<div class="toolbar-container">
						<div class="toolbar-left">
							<div class="tool-btn" @click="handleRefresh" title="刷新">
								<img :src="refreshIcon" alt="刷新" class="toolbar-icon">
							</div>
						</div>
						<div class="toolbar-right">
							<div class="action-btn add-appointment" @click="handleManualSign">
								<span>人工签到</span>
							</div>
						</div>
					</div>
				</template>
				<template slot="operate" slot-scope="scope">
					<el-button @click="handleEdit(scope.row)" size="small" type="text">编辑</el-button>
					<el-button type="text" style="color:rgb(24, 144, 255);" size="small"
						@click="handleAssignGroup(scope.row)">分配组别</el-button>
				</template>
			</myTableSearch>
		</div>
		<!-- 导入结果 -->
		<importResultDialog v-if="isImportResultDialog" :isDialog="isImportResultDialog" :resultData="importResultData"
			@handleClose="isImportResultDialog = false">
		</importResultDialog>
		<!-- 人工签到/分配组别 -->
		<manualSignDialog v-if="isManualSignDialog" :isDialog="isManualSignDialog" :isEdit="isEdit" :editData="editData"
			@handleClose="isManualSignDialog = false" @success="handleRefresh">
		</manualSignDialog>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getSignPage, deleteSign, getSignTemplate, importSign } from '@/api/industrialInjury/sign'
import { getListByDictType } from '@/api/sys/dictData'
import manualSignDialog from './components/manualSignDialog.vue'
import importResultDialog from './components/importResultDialog.vue'
import arrowLeftIcon from '@/assets/pages/appointment/arrow-l.png'
import arrowRightIcon from '@/assets/pages/appointment/arrow-r.png'
import refreshIcon from '@/assets/pages/appointment/refresh.png'
import deleteIcon from '@/assets/pages/appointment/delete.png'
import addIcon from '@/assets/pages/appointment/add.png'

export default {
	components: {
		manualSignDialog,
		importResultDialog,
	},
	data() {
		return {
			arrowLeftIcon,
			arrowRightIcon,
			refreshIcon,
			deleteIcon,
			addIcon,
			currentPage: 1,
			downloadTemplateLoading: false,
			importLoading: false,
			queryParams: {
				pageNum: 1,
				pageSize: 10,
				pageSizes: [10, 20, 50]
			},
			isEdit: false,
			editData: {},
			isImportResultDialog: false,
			importResultData: '',
			isManualSignDialog: false,
			signTypeList: [],
			formData: [
				{
					label: '签到方式',
					type: 'select',
					key: 'signType',
					data: []
				},
				{
					label: '分组',
					type: 'select',
					key: 'workInjuryCategoryCode',
					data: []
				},
				{
					label: '姓名',
					type: 'input',
					key: 'name'
				},
				{
					label: '身份证号',
					type: 'input',
					key: 'idNumber'
				},
				{
					label: '手机号',
					type: 'input',
					key: 'phone'
				},
				{
					label: '签到日期',
					type: 'daterange',
					key: 'signDate',
					screen: (value) => {
						if (value && value.length === 2) {
							return {
								signTimeStart: value[0],
								signTimeEnd: value[1]
							}
						}
						return {}
					}
				}
			],
			tableLabel: [
				{
					prop: 'name',
					label: '姓名',
				},
				{
					prop: 'idNumber',
					label: '身份证号码',
				},
				{
					prop: 'phone',
					label: '手机号',
				},
				{
					prop: 'workInjuryCategoryName',
					label: '分组',
				},
				{
					prop: 'subscribeTime',
					label: '预约时间',
				},
				{
					prop: 'signTime',
					label: '签到时间',
				},
				{
					prop: 'signType',
					label: '签到方式',
					slot: true
				},
			],
		}
	},
	created() {
		this.loadGroupData()
		this.loadSignTypeData()
	},
	methods: {
		queryFn(queryParams) {
			return getSignPage(queryParams)
		},
		async loadGroupData() {
			const res = await getListByDictType('industrial_injury_work_injury_category')
			if (res && res.code === 200 && res.data) {
				this.updateFormDataWithGroup(res.data)
			}
		},
		async loadSignTypeData() {
			const res = await getListByDictType('industrial_injury_sign_type')
			if (res && res.code === 200 && res.data) {
				this.updateFormDataWithSignType(res.data)
				this.signTypeList = res.data
			}
		},
		updateFormDataWithGroup(groupData) {
			if (!groupData) return

			const groupIndex = this.formData.findIndex(item => item.key === 'workInjuryCategoryCode')
			if (groupIndex !== -1) {
				this.$set(this.formData[groupIndex], 'data', groupData)
			}
		},
		updateFormDataWithSignType(signTypeData) {
			if (!signTypeData) return

			const signTypeIndex = this.formData.findIndex(item => item.key === 'signType')
			if (signTypeIndex !== -1) {
				this.$set(this.formData[signTypeIndex], 'data', signTypeData)
			}
		},
		handlePrevPage() {
			if (this.currentPage > 1) {
				this.currentPage--;
				this.queryParams.pageNum = this.currentPage;
				this.$refs.tableRef && this.$refs.tableRef.handleSearch();
			}
		},
		handleNextPage() {
			this.currentPage++;
			this.queryParams.pageNum = this.currentPage;
			this.$refs.tableRef && this.$refs.tableRef.handleSearch();
		},
		handleRefresh() {
			this.queryParams.pageNum = 1;
			this.currentPage = 1;
			this.$refs.tableRef && this.$refs.tableRef.handleSearch();
		},
		handleBatchDelete() {
			this.$refs.tableRef && this.$refs.tableRef.deleteAll();
		},
		getSignTypeLabel(signType) {
			if (!signType || !this.signTypeList.length) return '-'
			const item = this.signTypeList.find(t => String(t.dictValue) === String(signType))
			return item ? item.dictLabel : '-'
		},
		handleDownloadTemplate() {
			this.downloadTemplateLoading = true
			getSignTemplate().then(res => {
				if (res) {
					this.downloadBlobFile(res, '签到导入模板.xls');
				}
			}).finally(() => {
				this.downloadTemplateLoading = false
			})
		},
		handleImportFile(file) {
			const isExcel = file.raw.type === 'application/vnd.ms-excel' || 
				file.raw.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			const isLt10M = file.raw.size / 1024 / 1024 < 10

			if (!isExcel) {
				this.$message.error('只能上传 .xls 或 .xlsx 格式的文件！')
				return
			}
			if (!isLt10M) {
				this.$message.error('文件大小不能超过 10MB！')
				return
			}

			this.importLoading = true
			const formData = new FormData()
			formData.append('file', file.raw)

			importSign(formData).then(res => {
				if (res && res.code === 200) {
					this.importResultData = res.data
					this.isImportResultDialog = true
					this.handleRefresh()
				} else {
					this.$message.error(res.msg || '导入失败')
				}
			}).catch(err => {
				console.error('导入出错', err)
				this.$message.error('导入失败')
			}).finally(() => {
				this.importLoading = false
				this.$refs.uploadRef && this.$refs.uploadRef.clearFiles()
			})
		},
		handleManualSign() {
			this.isEdit = false
			this.editData = {}
			this.isManualSignDialog = true
		},
		handleAssignGroup(row) {
			this.isEdit = true
			this.editData = { ...row }
			this.isManualSignDialog = true
		},
		handleEdit(row) {
			this.isEdit = true
			this.editData = { ...row }
			this.isManualSignDialog = true
		},
		handleDel(row) {
			this.$confirm('确定要删除该预约吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				deleteCheckIn(row.id).then(res => {
					if (res && res.code === 200) {
						this.$message.success('删除成功')
						this.handleRefresh()
					} else {
						this.$message.error(res.msg || '删除失败')
					}
				}).catch(err => {
					console.error('请求出错', err)
					this.$message.error('删除失败')
				})
			}).catch(() => {})
		},
		successQuery(e) {
			this.syrkNum = e.total;
		},
	},
}
</script>

<style lang="scss" scoped>
.khpj {
	padding: 24px;

	border-radius: 5px;
	background: #ffffff;

	.khpjHead {
		width: 100%;

		.tabItem {
			display: flex;
			align-items: center;

			span {
				color: #0c7bf2;
				font-weight: bold;
				font-size: 16px;
			}

			img {
				padding-right: 8px;
				width: 24px;
				height: 24px;
			}
		}
	}

	.khpjContent {
		/deep/.myTableSearch {
			padding: 0;
		}
	}
}

.toolbar-container {
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 8px 0;

	.toolbar-icon {
		width: 24px;
		height: 24px;
	}

	.add-icon {
		width: 20px;
		height: 20px;
		margin-right: 6px;
	}

	.toolbar-left {
		display: flex;
		align-items: center;
		gap: 12px;

		.pagination-wrapper {
			display: flex;
			align-items: center;
			border: 1px solid #dcdfe6;
			overflow: hidden;

			.pagination-btn {
				width: 36px;
				height: 36px;
				display: flex;
				align-items: center;
				justify-content: center;
				background: #FCFCFCFF;
				cursor: pointer;
				transition: background-color 0.2s;

				&:hover {
					background: #409eff;
					color: #fff;
				}

				span {
					font-size: 14px;
					color: #606266;
				}

				&:hover span {
					color: #fff;
				}
			}

			.pagination-current {
				width: 42px;
				height: 36px;
				display: flex;
				align-items: center;
				justify-content: center;
				background: #fff;
				border-left: 1px solid #dcdfe6;
				border-right: 1px solid #dcdfe6;

				span {
					font-size: 14px;
					color: #606266;
				}
			}
		}

		.tool-btn {
			width: 36px;
			height: 36px;
			display: flex;
			align-items: center;
			justify-content: center;
			border: 1px solid #dcdfe6;
			cursor: pointer;
			transition: all 0.2s;
			background-color: #FCFCFCFF;

			.tool-btn-icon {
				font-size: 16px;
				color: #606266;
			}

			&:hover {
				border-color: #409eff;
				background: #ecf5ff;

				.tool-btn-icon {
					color: #409eff;
				}
			}
		}
	}

	.toolbar-right {
		display: flex;
		align-items: center;
		gap: 12px;

		.import-upload {
			display: inline-block;
		}

		.action-btn {
			height: 36px;
			padding: 0 16px;
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 4px;
			background: #297dee1a;
			cursor: pointer;
			transition: all 0.2s;
			font-size: 14px;
			color: #297deeff;

			&:hover {
				border-color: #409eff;
				color: #409eff;
			}

			&.disabled {
				opacity: 0.6;
				cursor: not-allowed;
			}

			&.add-appointment {
				background: #297deeff!important;
				border-color: #409eff!important;
				color: #fff!important;

				&:hover {
					background: #66b1ff!important;
					border-color: #66b1ff!important;
				}
			}
		}
	}
}
</style>
